var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.99955V18.9996C3 19.7713 3.83721 20.2522 4.50387 19.8633L16.5039 12.8633C17.1654 12.4775 17.1654 11.5217 16.5039 11.1358L4.50387 4.13577C3.83721 3.74689 3 4.22776 3 4.99955ZM5 6.73955L14.016 11.9996L5 17.2586V6.73955ZM20.9933 4.88293C20.9355 4.38559 20.5128 3.99955 20 3.99955C19.4477 3.99955 19 4.44727 19 4.99955V18.9996L19.0067 19.1162C19.0645 19.6135 19.4872 19.9996 20 19.9996C20.5523 19.9996 21 19.5518 21 18.9996V4.99955L20.9933 4.88293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.0f70542bc7598cebabcfc7bbd1926068.svg";
export { ForwardRef as ReactComponent };